import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

interface Testimonial {
    id: number;
    quote: string;
    author: string;
  }
  
  const Testimonials = () => {
    const testimonials: Testimonial[] = [
      {
        id: 1,
        quote: "Cooking hasn't been this easy; thankfully Easysauces came at the right time.",
        author: "Effiong Kate"
      },
      {
        id: 2,
        quote: "Convenience matters to me as a 9am to 5pm office worker. Thank you Easysauces.",
        author: "Mary Jane"
      },
      {
        id: 3,
        quote: "No additive, No chemical preservatives, All natural.",
        author: "Brenda Okafor"
      },
      {
        id: 4,
        quote: "Just sauce it with Easysauces.",
        author: "Sharon Kingsley"
      },
    ];
  
    return (
      <section className="testimonials py-5 bg-light">
        <div className="section-header text-center mt-5">
          <h3 className="section-title">WE LOVE GOOD COMPLIMENTS</h3>
        </div>
        <Swiper
          modules={[EffectCoverflow, Pagination, Autoplay]}
          effect="coverflow"
          grabCursor
          centeredSlides
          loop
          slidesPerView="auto"
          autoplay={{
            delay: 3000, // 3 seconds delay between slides
            disableOnInteraction: false, // Continue autoplay after user interaction
            pauseOnMouseEnter: true, // Pause on hover
          }}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          }}
          pagination={{
            el: '.testimonial-swiper-pagination',
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className}" style="width: 12px; height: 12px; margin: 0 6px;"></span>`;
            },
          }}
          className="testimonial-swiper overflow-hidden my-5"
          wrapperClass='d-flex'
        >
          {testimonials.map(testimonial => (
            <SwiperSlide key={testimonial.id}>
              <div className="testimonial-item text-center">
                <blockquote>
                  <p>“{testimonial.quote}”</p>
                  <div className="review-title text-uppercase">{testimonial.author}</div>
                </blockquote>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="testimonial-swiper-pagination d-flex justify-content-center mb-5"></div>
      </section>
    );
  };
  
  export default Testimonials;